import React, { useState } from 'react';
import { Box, Button, CircularProgress, Grid, Typography } from '@mui/material';
import { CustomeTextField } from '../../../generic/CustomeTextField';
import { PostcodeSearchByID } from '../../../generic/PostcodeSearchById';
import { useUpdateCourt } from '../../../hooks/reactQuerys/CourtQueries';
import { useAlert } from '../../../context/AlertContext';
import { courtSchema, ICourt } from '../../../Interfaces/ICourt';

interface IProps {
  currentCourt: ICourt;
  refetchCourts: Function;
}

export const EditCourt: React.FC<IProps> = ({
  currentCourt,
  refetchCourts,
}) => {
  const { showAlert } = useAlert();

  const [editCourt, setEditCourt] = useState(currentCourt);
  //
  const { updateCourt, isPendingCourt } = useUpdateCourt();
  const isPending = isPendingCourt;

  const handleReset = () => {
    setEditCourt(currentCourt);
  };

  const onUpdate = async () => {
    try {
      const updatedObject = await updateCourt(courtSchema.parse(editCourt));
      setEditCourt(updatedObject);
      refetchCourts();
      showAlert({
        text: 'Erfolgreich gespeichert!',
        severity: 'success',
      });
    } catch (error) {
      console.error(error);
      showAlert({
        text: 'Es ist ein Fehler aufgetreten!',
        severity: 'error',
      });
    }
  };

  return (
    <>
      <Typography variant='h6'>Gericht</Typography>

      <Grid container spacing={2}>
        <Grid item xs={4}>
          <CustomeTextField
            attr='XJustizID'
            object={editCourt}
            label='XJustiz-ID'
            setObject={setEditCourt}
            type='string'
          />
        </Grid>
        <Grid item xs={8}>
          <CustomeTextField
            attr='Court'
            object={editCourt}
            label='Gericht'
            setObject={setEditCourt}
            type='string'
            required
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} sx={{ mt: 2 }}>
        <Grid item xs={8}>
          <CustomeTextField
            attr='Street'
            object={editCourt}
            label='Straße'
            setObject={setEditCourt}
            type='string'
          />
        </Grid>
        <Grid item xs={4}>
          <CustomeTextField
            attr='StreetNr'
            object={editCourt}
            label='Nr'
            setObject={setEditCourt}
            type='string'
          />
        </Grid>
        <Grid item xs={12}>
          <PostcodeSearchByID
            key={`postcode-${editCourt.idPostcode}`}
            idPostcode={editCourt.idPostcode}
            setIdPostcode={(idPostcode: number) =>
              setEditCourt({
                ...editCourt,
                idPostcode: idPostcode,
              })
            }
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} sx={{ mt: 2 }}>
        <Grid item xs={6}>
          <CustomeTextField
            attr='PhoneNumber'
            object={editCourt}
            label='Telefonnummer'
            setObject={setEditCourt}
            type='string'
          />
        </Grid>
        <Grid item xs={6}>
          <CustomeTextField
            attr='Court_Email'
            object={editCourt}
            label='E-Mail'
            setObject={setEditCourt}
            type='string'
          />
        </Grid>
      </Grid>

      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
        {/*<Button variant='outlined'>Neue Gemarkung</Button>*/}
        <Button variant='outlined' onClick={handleReset} disabled={isPending}>
          Zurücksetzen
        </Button>
        <Button variant='contained' disabled={isPending} onClick={onUpdate}>
          {isPending ? (
            <Box display='flex' alignItems='center' gap={1}>
              <span>Speichern</span>
              <CircularProgress size={20} />
            </Box>
          ) : (
            'Speichern'
          )}
        </Button>
      </Box>
    </>
  );
};
